import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';

import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  NgForm,
  UntypedFormBuilder,
} from '@angular/forms';
import { SelectItem, Message } from 'primeng';
import { Router } from '@angular/router';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { ITruckForm } from '../../interfaces/truck-form';
import { ITrucks } from '../../interfaces/trucks';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import { BBWTMessageService, OrganisationsService } from '../../services';
import { SupplierService } from '../../services';
import { TrucksService } from '../../services';

@Component({
  templateUrl: './new-truck.component.html',
  styleUrls: ['./new-truck.component.css'],
})
export class NewTruckComponent implements OnInit {
  public truck: ITruckForm;
  public newTruckForm: UntypedFormGroup;
  public uLevel: IUserOrganisationLevel;
  truckTypes: SelectItem[];
  public msgs: any[];

  depots: SelectItem[];
  regions: SelectItem[];
  selectedRegion: any;
  public searchingDepots: boolean = false;

  constructor(
    private trucksService: TrucksService,
    private router: Router,
    private supplierService: SupplierService,
    private organisationsService: OrganisationsService,
    private formBuilder: UntypedFormBuilder,
    private messageService: BBWTMessageService,
  ) {
    this.vehicleChange = new EventEmitter<ITrucks>();
  }

  ngOnInit() {
    this.getTruckTypes();
    const regexpAllIsIs = new RegExp(/^\d+$/);
    // set formGroup instance
    this.truck = {
      id: 0,
      regionId: new UntypedFormControl(''),
      depotId: new UntypedFormControl(''),
      typeId: new UntypedFormControl(''),
      assetNumber: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
      ),
      capacity: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.pattern(regexpAllIsIs),
          Validators.min(0),
          Validators.max(1000000),
        ]),
      ),
      capacityTowing: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.pattern(regexpAllIsIs),
          Validators.min(0),
          Validators.max(1000000),
        ]),
      ),
      description: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
      registration: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(8),
          NoEmptyString,
        ]),
      ),
      make: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
      model: new UntypedFormControl(
        '',
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
    };

    this.newTruckForm = this.formBuilder.group({
      regionId: this.truck.regionId,
      depotId: this.truck.depotId,
      assetNumber: this.truck.assetNumber,
      typeId: this.truck.typeId,
      capacity: this.truck.capacity,
      capacityTowing: this.truck.capacityTowing,
      description: this.truck.description,
      regNumberSearch: new UntypedFormControl(''),
      vehicleInfo: this.formBuilder.group({
        registration: this.truck.registration,
        make: this.truck.make,
        model: this.truck.model,
      }),
    });

    //level settings
    this.organisationsService.getUserOrganisationLevel().then((resp) => {
      this.uLevel = resp;

      this.getRegions();

      this.truck.regionId.setValidators(Validators.required);
      this.truck.depotId.setValidators(Validators.required);
    });
    //
  }

  pageValidate(): boolean {
    return this.newTruckForm.valid && this.vehicle != null;
  }

  save(formValues) {
    var obj = {
      id: 0,
      regionId: formValues.regionId || 0,
      depotId: formValues.depotId || 0,
      typeId: formValues.typeId,
      assetNumber: formValues.assetNumber,
      capacity: formValues.capacity,
      capacityTowing: formValues.capacityTowing,
      description: formValues.description,
      make: this.vehicle.make,
      model: this.vehicle.model,
      registration: this.vehicle.registration,
      depot: null,
    };

    this.trucksService
      .create(obj)
      .then((res) => {
        this.router.navigate(['app/trucks']);
      })
      .catch((error) => {
        const errorMessage = typeof error === 'string' ? error : 'Truck already exists.';
        this.messageService.ShowError('Error', errorMessage, 3);
      });
  }

  /*********************** Search Vehicle ***********************/
  public vehicleMsgs: Array<string> = [];
  public regNumberSearch: string;
  @Output() vehicleChange: EventEmitter<ITrucks>;
  private _vehicle: ITrucks;
  @Input('vehicle')
  public set vehicle(value: ITrucks) {
    this._vehicle = value;
    this.vehicleChange.emit(value);
  }
  public get vehicle(): ITrucks {
    return this._vehicle;
  }

  public isSearchVehicle: boolean = false;
  public isShowVehicleDetail: boolean = false;
  public isShowSearchManual: boolean = false;

  SearchVehicle() {
    this.isSearchVehicle = true;
    this.vehicle = null;
    this.isShowSearchManual = false;
    this.isShowVehicleDetail = false;
    var that = this;
    this.trucksService
      .GetByRegNum(this.regNumberSearch)
      .then((truckVehicle) => {
        that.vehicle = truckVehicle;

        if (truckVehicle == null) {
          this.messageService.ShowWarning('Warning', 'Vehicle not Found');
        }
        that.isSearchVehicle = false;
        this.isShowVehicleDetail = true; //so we show details for edition immediatelly (without [car details] [Edit Details] dialog)
      })
      .catch(() => {
        that.vehicle = null;
        that.isSearchVehicle = false;
        this.messageService.ShowWarning('Warning', 'Vehicle not found.');
      });
  }

  ShowVehicleDetails() {
    this.isShowVehicleDetail = true;
  }

  limitCapacity(element) {
    var max_chars = 7;
    if (element.srcElement.value.length > max_chars) {
      this.newTruckForm.patchValue({
        capacity: element.srcElement.value.substr(0, max_chars),
      });
    }
  }

  limitCapacityTowing(element) {
    var max_chars = 7;
    if (element.srcElement.value.length > max_chars) {
      this.newTruckForm.patchValue({
        capacityTowing: element.srcElement.value.substr(0, max_chars),
      });
    }
  }

  NoRegistration() {
    this.vehicle = {
      id: 0,
      regionId: 0,
      depotId: 0,
      depot: null,
      typeId: 0,
      assetNumber: '',
      capacity: '',
      capacityTowing: '',
      description: '',
      make: '',
      model: '',
      registration: '',
    };

    this.newTruckForm.controls['vehicleInfo'].reset();
    this.isShowSearchManual = true;
  }
  /* End Search Vehicle */

  getRegions() {
    this.supplierService.getRegions().then((result) => {
      var allRegions = [];
      if (this.uLevel.isAllDepots) {
        allRegions = result;
      } else if (this.uLevel.isCertainDepots) {
        allRegions = result.filter((x) => this.uLevel.regionId.indexOf(x.id) > -1);
      }

      this.regions = [];
      if (allRegions != null) {
        allRegions.forEach((item) => {
          this.regions.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  getDepots(regionId: number) {
    this.searchingDepots = true;

    this.supplierService.getDepots(regionId).then((result) => {
      var allDepots = [];
      if (this.uLevel.isAllDepots) {
        allDepots = result;
      } else if (this.uLevel.isCertainDepots) {
        allDepots = result.filter(
          (x) => this.uLevel.depotId.filter((t) => t.id == x.id).length != 0,
        );
      }

      this.depots = [];
      if (allDepots != null) {
        allDepots.forEach((item) => {
          this.depots.push({ label: item.name, value: item.id });
        });
      }

      this.searchingDepots = false;

      this.truck.depotId.setValue(null);
    });
  }

  onRegionChange(eventValue: any) {
    this.getDepots(eventValue);
  }

  getTruckTypes() {
    this.trucksService.getTruckTypes().then((result) => {
      this.truckTypes = [];
      if (result != null) {
        result.forEach((item) => {
          this.truckTypes.push({ label: item.name, value: item.id });
        });
      }
    });
  }
}
